export const LOADING = 'LOADING';
export const LOGIN_USER = 'LOGIN_USER';
